"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const react_tree_1 = require("@naisutech/react-tree");
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const pretty_bytes_1 = __importDefault(require("pretty-bytes"));
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const Audiences_1 = require("../../../common/js/constants/Audiences");
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const dateformat_1 = require("../../../common/js/helper/dateformat");
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const ReactTableTheme_1 = require("../../constants/ReactTableTheme");
const reactTree_1 = require("../../helper/reactTree");
const ResellerFileExplorerStore_1 = __importDefault(require("../../stores/ResellerFileExplorerStore"));
const AuthorizedLink_1 = __importDefault(require("../AuthorizedLink"));
const TableSub_1 = __importDefault(require("../TableSub"));
const ResellerFileExplorer = ({ relativePath, }) => {
    const [selectedPath, setSelectedPath] = (0, react_1.useState)();
    const [openNode, setOpenNode] = (0, react_1.useState)();
    const [loadingDirectoryContent, setLoadingDirectoryContent] = (0, react_1.useState)(false);
    const treeNodes = (0, reactTree_1.convertResellerStructureToTreeNodeList)(ResellerFileExplorerStore_1.default.structure(relativePath));
    (0, react_1.useEffect)(() => {
        ResellerFileExplorerStore_1.default.loadStructure(relativePath);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!selectedPath) {
            return;
        }
        const loadedPath = selectedPath;
        const selectedPaths = selectedPath
            .split('/')
            .reduce((paths, path) => [
            ...paths,
            [paths[paths.length - 1], path].filter((item) => !!item).join('/'),
        ], []);
        setOpenNode(selectedPaths);
        setLoadingDirectoryContent(true);
        ResellerFileExplorerStore_1.default.loadFiles(selectedPath).finally(() => {
            if (loadedPath !== selectedPath) {
                return;
            }
            setLoadingDirectoryContent(false);
        });
    }, [selectedPath]);
    return (react_1.default.createElement("div", { className: "znd-reseller-file-explorer" }, ResellerFileExplorerStore_1.default.isLoading || !ResellerFileExplorerStore_1.default.structure(relativePath).length ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "mx-auto" })) : (react_1.default.createElement("div", { className: "row" },
        react_1.default.createElement("div", { className: "znd-res col-lg-3 col-7 col-md-5" },
            react_1.default.createElement(react_tree_1.ReactTree, { nodes: treeNodes, themes: ReactTableTheme_1.ReactTableTheme, theme: "zkp", containerStyles: { padding: 0 }, onToggleSelectedNodes: (nodes) => nodes.length > 0 ? setSelectedPath(nodes[0].toString()) : void 0, openNodes: openNode, enableItemAnimations: true, RenderIcon: ({ open, type, node }) => node.id === selectedPath && type === 'leaf' ? (react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: "btn__icon-left znd-reseller-file-explorer__tree-icon" })) : open ? (react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: "btn__icon-down znd-reseller-file-explorer__tree-icon" })) : (react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretRight, className: "btn__icon-left znd-reseller-file-explorer__tree-icon" })), RenderNode: ({ node, type }) => (react_1.default.createElement("div", { className: "znd-reseller-file-explorer__tree__node" },
                    react_1.default.createElement("p", { className: (0, classnames_1.default)({
                            'znd-reseller-file-explorer__tree__label-selected': node.id === selectedPath,
                            'ml-1': type === 'leaf',
                        }) }, node.label))) })),
        react_1.default.createElement("div", { className: "col-lg-9 col-5 col-md-7 znd-reseller-file-explorer__files" }, ResellerFileExplorerStore_1.default.structure(relativePath) && selectedPath ? (loadingDirectoryContent ? (react_1.default.createElement(LoadingSpinner_1.default, { className: "mx-auto" })) : (react_1.default.createElement(TableSub_1.default, { key: selectedPath, columns: [
                {
                    id: 'name',
                    name: (0, translation_1.t)('reseller.file_explorer.table.header.name'),
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row, index, column) => {
                        return (react_1.default.createElement(AuthorizedLink_1.default, { className: "znd-reseller-file-explorer__file-link my-1 d-flex align-items-center", href: `https://${__APP__.DOWNLOADS_HOST}/api/v1/reseller/download/${row.key}`, audience: Audiences_1.Audiences.DOWNLOADS, scopes: [AuthorizationScopes_1.default.RESELLER_READ] },
                            column.selector?.(row, index).toString() ?? '',
                            react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.angleRight, className: "ml-1" })));
                    },
                },
                {
                    id: 'date',
                    name: (0, translation_1.t)('reseller.file_explorer.table.header.date'),
                    selector: (row) => (row.date ? (0, dateformat_1.getDateFormat)(new Date(row.date)) : null) ?? '',
                    sortable: true,
                    maxWidth: '20%',
                },
                {
                    id: 'size',
                    name: (0, translation_1.t)('reseller.file_explorer.table.header.size'),
                    selector: (row) => row.size,
                    format: (row) => (0, pretty_bytes_1.default)(row.size),
                    sortable: true,
                    right: true,
                    maxWidth: '20%',
                },
            ], data: ResellerFileExplorerStore_1.default.getFiles(selectedPath), noDataComponent: (0, translation_1.t)('reseller.file_explorer.no_data'), tableProps: {
                sortIcon: (react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: 'btn__icon-down znd-reseller-file-explorer__tree-icon ml-1' })),
                defaultSortFieldId: 'name',
                defaultSortAsc: true,
            } }))) : null)))));
};
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scope: AuthorizationScopes_1.default.RESELLER_READ })((0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(ResellerFileExplorer))));
